import { Record } from 'immutable';

const ItemRecord = Record({
  questionNo: undefined,
  question: undefined,
  studentAnswer: undefined,
  isCorrect: undefined,
});

class Item extends ItemRecord { }

export default Item;




// WEBPACK FOOTER //
// ./data/WritingAssignment/ShortAnswer/model/Item/model.js